(function (angular) {
	'use strict';

	angular
		.module('viewPlanModule')
		.controller('ComparePlans', [
			'$scope',
			'$window',
			'BREAKPOINTS',
			'planFactory',
			ComparePlansFunction
		]);

	function ComparePlansFunction(
		$scope,
		$window,
		BREAKPOINTS,
		planFactory) {
		
		var comparePlans = this;
		comparePlans.breakdown = 'structure';
		comparePlans.planData = {};
		comparePlans.allocationByProperty = {};
		comparePlans.showSticky = false;
		comparePlans.planNames = [];

		planFactory.getPlanData(['STANDARD']).then(function(response){
			angular.forEach(response.data, function(planData){
				var allocationByPropertyData = planFactory.getAllocationByProperty(planData.allocationByRating);
				var planDataWithCapStack = planData;
				comparePlans.planData[planData.name] = planDataWithCapStack;
				comparePlans.allocationByProperty[planData.name] = allocationByPropertyData;
				comparePlans.planNames.push(planData.name);
			});
		});

		comparePlans.selectedIndex = 1;
		comparePlans.position = {
			'left': '-70%'
		};

		if($window.innerWidth < BREAKPOINTS.MD_START) {
			angular.element($window).bind("scroll", function() {
				if(this.pageYOffset > 100) {
					comparePlans.showSticky = true;
				} else {
					comparePlans.showSticky = false;
				}

				$scope.$apply();
			});
		}

		function updatePosition() {
			comparePlans.position.left = (comparePlans.selectedIndex * -80 + 10) + '%';
		}

		comparePlans.increment = function() {
			if(comparePlans.selectedIndex <= 1) {
				comparePlans.selectedIndex += 1;
				updatePosition();
			}
		};

		comparePlans.decrement = function() {
			if(comparePlans.selectedIndex >= 1) {
				comparePlans.selectedIndex -= 1;
				updatePosition();
			}
		};
	}
})(window.angular);